import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/layout/Navbar";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowLeft, Compass } from "lucide-react";

const NotFound = () => {
  const { isAuthenticated } = useAuth();
  return (
    <div className="min-h-screen bg-background">
      {isAuthenticated && <Navbar />}
      <div className="flex min-h-[calc(100vh-4rem)] flex-col items-center justify-center px-4 py-16 text-center">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-primary/10">
          <Compass className="h-10 w-10 text-primary" />
        </div>
        <h1 className="mb-2 text-6xl font-extrabold tracking-tight">404</h1>
        <p className="mb-2 text-xl font-semibold">Page not found</p>
        <p className="mb-8 max-w-sm text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Button asChild variant="default" className="gap-2">
          <Link to="/">
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
